import { useEffect, useState } from "react";
// Keeping import for future insurance selection UI implementation
// import DropDownMenu from "../../../../../containers/QuestionnaireParent/QuestionOptionsLibrary/components/DropDownMenu/DropDownMenu";
import RadioBoxContainer from "../../../../../containers/QuestionnaireParent/QuestionOptionsLibrary/components/RadioBox/RadioBoxContainer";
import AppButton from "../../../../../components/base/Button/Button";
import "./VerifyInsuranceToDo.scss";
import {
    cancelOnboarding,
    changeTodoStatusV1,
    patchUser,
} from "../../../../../api/user";
import { updateIfollowedUpTodo } from "../../../../../redux/services/loggingServices";
import { useDispatch } from "react-redux";
import { clearModalContent } from "../../../../../redux/modules/modalEvent";
import {
    payOutOfPocket,
 
} from "../../../../../redux/services/questionnaireServices";
import { Logger } from 'src/latest/src/services';

type Props = {
    todo: any;
    onVerified: () => void;
};

const VerifyInsuranceToDo = ({ todo, onVerified }: Props) => {
    const choices = [
        {
            active: true,
            description: null,
            language: "en",
            place_holder: null,
            sequence: 10,
            title: "Yes",
            unique_key: "yesInsuranceAvailableSecondaryExistingClientChoiceV1",
            id: "yesInsuranceAvailableSecondaryExistingClientChoiceV1",
            value: null,
        },
        {
            active: true,
            description: null,
            language: "en",
            place_holder: null,
            sequence: 20,
            title: "No",
            unique_key: "noInsuranceAvailableSecondaryExistingClientChoiceV1",
            id: "noInsuranceAvailableSecondaryExistingClientChoiceV1",
            value: null,
        },
    ];

    const optionalChoices = [
        {
            active: true,
            description: null,
            language: "en",
            place_holder: null,
            sequence: 10,
            title: "Pay out of pocket",
            unique_key: "payoutofpocket",
            id: "payoutofpocket",
            value: null,
        },
        {
            active: true,
            description: null,
            language: "en",
            place_holder: null,
            sequence: 20,
            title: "Cancel match request",
            unique_key: "cancelmatchrequest",
            id: "cancelmatchrequest",
            value: null,
        },
    ];

    const [primaryChoices, setPrimaryChoices] = useState(choices);
    const [secondaryChoices, setSecondaryChoices] = useState(optionalChoices);
    const [primaryQuestionValue, setPrimaryQuestionValue] = useState("");
    const [primaryInsurance, setPrimaryInsurance] = useState<any>({});
    // State variables for future insurance selection implementation
    /* const [secondaryInsurance, setSecondaryInsurance] = useState<any>({});
    const [tertiaryInsurance, setTertiaryInsurance] = useState<any>({}); */
    const [isContinueButtonEnabled, setIsContinueButtonEnabled] =
        useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingPendingToDo, setLoadingPendingToDo] = useState(false);
    // State for future insurance selection implementation
    /* const [insuranceList, setInsuranceList] = useState([]); */

    const dispatch = useDispatch();

    const updateInsuranceVerificationStatus = async () => {
        const apiData: any = { insurance_metadata: {} };

        if (Object.keys(primaryInsurance).length !== 0)
            apiData.insurance_metadata[primaryInsurance.unique_key] =
                primaryInsurance.title;
                
        // Insurance metadata handling for future implementation
        /* if (Object.keys(secondaryInsurance).length !== 0)
            apiData.insurance_metadata[secondaryInsurance.unique_key] =
                secondaryInsurance.title;
        if (Object.keys(tertiaryInsurance).length !== 0)
            apiData.insurance_metadata[tertiaryInsurance.unique_key] =
                tertiaryInsurance.title; */
        setLoading(true);

        try {
            if (secondaryChoices[1].value === "Cancel match request") {
                await cancelOnboarding(todo.user_id);
                onVerified();
                dispatch(clearModalContent());

                return;
            } else if (secondaryChoices[0].value === "Pay out of pocket") {
                await payOutOfPocket(todo.user_id);
                dispatch(clearModalContent());
            } else {
                await patchUser(todo.user_id, apiData);
            }

            await createFollowUp();
        } catch (e) {
            setLoading(false);
            console.error(e);
        }
    };

    const createFollowUp = async () => {
        const respObj = {
            follow_up_by: ["SELF"],
            note: ``,
        };

        try {
            await updateIfollowedUpTodo(todo.id, respObj);
            dispatch(clearModalContent());
            onVerified();
        } catch (e) {
            Logger.log("Follow up error", e);
        }
    };

    useEffect(() => {
        if (
            primaryQuestionValue === "Yes" ||
            (primaryQuestionValue === "No" &&
                (secondaryChoices[1].value === "Cancel match request" ||
                    secondaryChoices[0].value === "Pay out of pocket"))
        ) {
            setIsContinueButtonEnabled(true);
        } else {
            setIsContinueButtonEnabled(false);
        }
    }, [primaryInsurance, secondaryChoices, primaryQuestionValue]);

    const markToDoAsPending = async () => {
        const note = "";

        setLoadingPendingToDo(true);

        try {
            await changeTodoStatusV1(todo.id, false, note);
            onVerified();

            dispatch(clearModalContent());
        } catch (e) {
            Logger.log(e);
        }

        setLoadingPendingToDo(false);
    };

    useEffect(() => {
        if (primaryQuestionValue === "Yes") {
            setSecondaryChoices(optionalChoices);
        } else if (primaryQuestionValue === "No") {
            setPrimaryInsurance({});
        }
    }, [primaryQuestionValue]);

    // Function for future insurance selection implementation
    /* const handleInsurance = async () => {
        const result = await getAllInsurances();
        const selectedInsuranceKeys = [
            primaryInsurance?.unique_key,
            secondaryInsurance?.unique_key,
            tertiaryInsurance?.unique_key,
        ].filter(Boolean);

        const filteredList = result.choices.filter(
            (insurance: any) =>
                !selectedInsuranceKeys.includes(insurance.unique_key)
        );

        setInsuranceList(filteredList);
    };

    useEffect(() => {
        handleInsurance();
    }, [primaryInsurance, secondaryInsurance, tertiaryInsurance]); */

    return (
        <div className="question-container">
            <div className="question-title">
                Does {todo?.user_full_name} have verified insurance?
            </div>
            <RadioBoxContainer
                className="mt-4"
                onChange={(updatedChoices: any) => {
                    setPrimaryChoices(updatedChoices);
                    const value = updatedChoices.filter((uc: any) => {
                        if (uc.selected) {
                            return uc;
                        } else {
                            return false;
                        }
                    })[0].value;

                    value && setPrimaryQuestionValue(value);
                }}
                choices={primaryChoices}
            />
            <div className="second-question">
                {/* NOTE: REMOVED AS OF NOW - Will add it back if needed in future */}
                {/* {primaryQuestionValue === "Yes" && (
                    <>
                        <div className="question-title mb-3 mt-5 text-uppercase">
                            Select insurance you have verified
                        </div>
                        <DropDownMenu
                            title="Insurance 1"
                            menu={insuranceList}
                            className="primary-insurance mb-3"
                            onChangeValue={(v: any) => {
                                setPrimaryInsurance(v);
                            }}
                        />
                        <DropDownMenu
                            title="Insurance 2 (optional)"
                            menu={insuranceList}
                            className="secondary-insurance mb-3"
                            onChangeValue={(v: any) => {
                                setSecondaryInsurance(v);
                            }}
                        />
                        <DropDownMenu
                            title="Insurance 3 (optional)"
                            menu={insuranceList}
                            className="tertiary-insurance"
                            onChangeValue={(v: any) => {
                                setTertiaryInsurance(v);
                            }}
                        />
                    </>
                )} */}
                {primaryQuestionValue === "No" && (
                    <>
                        <div className="question-title mb-0 mt-5 text-uppercase">
                            Client decided to:
                        </div>
                        <RadioBoxContainer
                            className="mt-4"
                            onChange={(updatedChoices: any) =>
                                setSecondaryChoices(updatedChoices)
                            }
                            choices={secondaryChoices}
                        />
                    </>
                )}
            </div>
            <div className="buttons">
                <AppButton
                    label="Continue"
                    className="mt-5"
                    disabled={
                        !isContinueButtonEnabled ||
                        loading ||
                        loadingPendingToDo
                    }
                    isProcessing={loading}
                    onClick={updateInsuranceVerificationStatus}
                />
                <AppButton
                    onClick={markToDoAsPending}
                    className="mt-4"
                    style={{ backgroundColor: "white" }}
                    variant="light"
                    disabled={
                        loadingPendingToDo || loading || todo.active === false
                    }
                    isProcessing={loadingPendingToDo}
                    label="Mark Verify TO-DO as pending"
                />
            </div>
        </div>
    );
};

export default VerifyInsuranceToDo;
